import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Divider, Space, Typography } from "antd";
import { LogoIcon } from "assets/icons";
import { signUp } from "stores/slices/user";

import SignUpForm from "components/forms/signUpForm";

import SocialLogin from "./socialLogin";

import styles from "./styles.module.scss";

const signUpPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [isSignupSuccess, setIsSignupSuccess] = useState(false);
  const [email, setEmail] = useState("");
  const [isAgreeTermsOfService, setIsAgreeTermsOfService] = useState(false);

  const handleSubmit = async values => {
    if (isAgreeTermsOfService) {
      setLoading(true);

      const { payload } = await dispatch(signUp(values));

      if (payload && payload.status === 200) {
        setIsSignupSuccess(true);
        setLoading(false);
        setEmail(values.email);
      } else {
        setIsSignupSuccess(false);
        setLoading(false);
      }
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authContent}>
        <div className={styles.authLogo}>
          <LogoIcon />
        </div>
        <div className={styles.authForm}>
          {!isSignupSuccess && (
            <div>
              <SignUpForm
                onSubmit={handleSubmit}
                loading={loading}
                setIsAgreeTermsOfService={setIsAgreeTermsOfService}
                isAgreeTermsOfService={isAgreeTermsOfService}
              />
              <Divider>
                <span style={{ color: "#9499A0" }}>OR</span>
              </Divider>
              <SocialLogin loading={loading} />
            </div>
          )}

          {isSignupSuccess && (
            <div>
              <Space
                direction="vertical"
                size="small"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography className={styles.signUpSuccessTitle}>
                  {t("signUp.signUpSuccessTitle")}
                </Typography>
                <div
                  style={{ textAlign: "center", lineHeight: 1.5 }}
                  dangerouslySetInnerHTML={{
                    __html: t("signUp.signUpSuccessMsg", { email: email }),
                  }}
                ></div>
              </Space>
            </div>
          )}

          <Space
            direction="horizontal"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <span>{`${t("label.signInMessage")} `}</span>
            <Link
              to="/auth/sign-in"
              style={{
                fontWeight: 700,
                pointerEvents: loading ? "none" : "auto",
              }}
            >
              {t("label.signIn")}
            </Link>
          </Space>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a
              target="_blank"
              href="https://messageclub.com/privacy-policy.html"
              rel="noreferrer"
              style={{ marginRight: 10, fontSize: 14, color: "#1F2A37" }}
            >
              Privacy Policy
            </a>
            <a
              target="_blank"
              href="https://messageclub.com/term-of-service.html"
              rel="noreferrer"
              style={{ fontSize: 14, color: "#1F2A37" }}
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default signUpPage;
